<template>
  <div class="form-container">
    <h1 class="page-title">見積小分類マスタ新規作成</h1>

    <div v-if="!isAdmin" class="alert alert-danger">
      見積小分類の登録権限がありません。
      <router-link :to="listRoute">一覧へ戻る</router-link>
    </div>

    <template v-else>
      <div v-if="errorMessages.length" class="alert alert-danger">
        <div v-for="message in errorMessages" :key="message">{{ message }}</div>
      </div>

      <EstimateSubcategoryForm
        :initial-data="initialData"
        :business-classifications="businessClassifications"
        :errors="fieldErrors"
        :submitting="submitting"
        submit-label="登録"
        @submit="createSubcategory"
        @cancel="router.push(listRoute)"
      />
    </template>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import EstimateSubcategoryForm from '@/components/estimateSubcategories/EstimateSubcategoryForm.vue';
import {
  createEstimateSubcategory,
  getBusinessClassifications
} from '@/api/axios';
import { extractApiErrors } from '@/utils/estimates';

document.title = '見積小分類マスタ新規作成';

const router = useRouter();
const route = useRoute();
const store = useStore();
const listRoute = computed(() => ({
  name: 'EstimateSubcategoryList',
  query: route.query
}));
const isAdmin = computed(() => [0, 999].includes(Number(store.state.userRole)));
const businessClassifications = ref([]);
const submitting = ref(false);
const errorMessages = ref([]);
const fieldErrors = ref({});
const initialData = {
  m_business_classification_id: '',
  subcategory_nm: '',
  subcategory_nm_en: ''
};

const loadBusinessClassifications = async () => {
  try {
    const response = await getBusinessClassifications({ deleted_status: 'active' });
    businessClassifications.value = response.data || [];
  } catch (error) {
    errorMessages.value = extractApiErrors(error);
  }
};

const createSubcategory = async (payload) => {
  submitting.value = true;
  errorMessages.value = [];
  fieldErrors.value = {};

  try {
    await createEstimateSubcategory(payload);
    store.dispatch('setFlashMessage', {
      message: '見積小分類を登録しました',
      type: 'success'
    });
    await router.push(listRoute.value);
  } catch (error) {
    errorMessages.value = extractApiErrors(error);
    fieldErrors.value = error.response?.data?.errors || {};
  } finally {
    submitting.value = false;
  }
};

onMounted(() => {
  if (isAdmin.value) loadBusinessClassifications();
});
</script>
